module.exports = __webpack_public_path__ + "media/img/controls-cf74dc23.png";